"use client";

import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary, {
  accordionSummaryClasses,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
      transform: "rotate(90deg)",
    },
  [`& .${accordionSummaryClasses.content}`]: {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const faqs = [
  {
    question: "What is YNET Solutions?",
    answer:
      "YNET Solutions is a tech company based in Nairobi, Kenya, providing innovative software solutions for SMEs since 2020.",
  },
  {
    question: "What services do you offer?",
    answer:
      "We offer custom software development, mobile/web apps, cloud hosting, UI/UX design, e-commerce solutions, and IT consulting.",
  },
  {
    question: "Why should I choose YNET Solutions?",
    answer:
      "We provide end-to-end solutions, a flexible approach, a skilled team, transparent communication, and proven client success.",
  },
  {
    question: "Which industries do you work with?",
    answer:
      "Our clients span across retail, finance, healthcare, real estate, education, tourism, and event sectors.",
  },
  {
    question: "What technologies do you use?",
    answer:
      "We work with React, Vue, Angular, Node.js, Python, Java, Flutter, MongoDB, PostgreSQL, Docker, AWS, and more.",
  },
  {
    question: "Can you support digital transformation for SMEs?",
    answer:
      "Absolutely! We help businesses modernize operations through scalable, intelligent, and user-friendly tech solutions.",
  },
];

const FaqContent = () => {
  const [expanded, setExpanded] = React.useState("panel0");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Box
      sx={{
        pb: { xs: "60px", sm: "60px", md: "80px", lg: "100px", xl: "150px" },
      }}
      className="faq-area"
    >
      <Box className="section-title text-center">
        <div className="sub-title">
          <span className="text-purple">FAQ's</span>
        </div>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "24px", md: "28px", lg: "34px", xl: "36px" },
          }}
        >
          Do You Have Questions? We Have Answers (Well, Most of the Time!)
        </Typography>
      </Box>

      <Box sx={{ maxWidth: "738px", px: "15px", mx: "auto" }}>
        {faqs.map((item, index) => (
          <Accordion
            key={index}
            expanded={expanded === `panel${index}`}
            onChange={handleChange(`panel${index}`)}
            className="toc-accordion bg-white"
            sx={{
              border: "none",
              borderRadius: "7px",
              mt: "10px",
            }}
          >
            <AccordionSummary
              aria-controls={`panel${index}d-content`}
              id={`panel${index}d-header`}
              className="bg-white"
              sx={{
                padding: "9px 25px",
                borderRadius: "7px",
              }}
            >
              <Typography
                variant="h4"
                fontWeight={600}
                fontSize="14px"
                className="text-black"
              >
                {item.question}
              </Typography>
            </AccordionSummary>

            <AccordionDetails
              sx={{
                border: "none",
                padding: "0 25px 5px",
              }}
            >
              <Typography sx={{ lineHeight: "1.8" }} mb="15px">
                {item.answer}
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default FaqContent;